import React from "react";
import {timeIntervals} from "../../../Constant";
export const StatusHeader = (rest)=> {
    return (
        <div><span className="protocol">Status</span>
            <span
                className="protocol-list">for {timeIntervals[rest.timeInterval].value}</span></div>
    )
};